import {
  Button,
  Card,
  Col,
  Divider,
  Row,
  Space,
  Typography,
  Spin,
  Empty,
  List,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { getPublicAccount } from "../../../services/public.service";
import { formatCurrency } from "../../../services/utils";
import { frequencies } from "../../../Enums/Frequency.enums";

const { Text, Title } = Typography;

export default function MyPublicPlansPage() {
  const { accountUuid } = useParams();
  const navigate = useNavigate();

  const { data: accountResponse, isLoading: loadingAccount } = useQuery(
    ["loadPublicAccount", accountUuid],
    () => (accountUuid ? getPublicAccount(accountUuid) : null),
    { refetchOnWindowFocus: false }
  );

  const account = accountResponse?.data || {};
  const plans = account?.plans || [];

  const handleSubscribe = (planUuid: string) => {
    navigate(`/plans/${accountUuid}/checkout/${planUuid}`);
  };

  if (loadingAccount) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 960, margin: "0 auto", padding: "20px" }}>
      <Card
        styles={{
          header: { color: "#107B99", fontWeight: 600 },
          body: { padding: 0 },
        }}
        title="Contratação de Planos"
      >
        <div style={{ padding: 24 }}>
          <Row gutter={16} align="middle">
            <Col span={24} style={{ textAlign: "center", marginBottom: 24 }}>
              <Space direction="vertical" size={2}>
                {account?.thumbnail && (
                  <img
                    src={account?.thumbnail}
                    alt={account?.name}
                    style={{
                      height: 86,
                      objectFit: "contain",
                      marginBottom: 8,
                    }}
                  />
                )}
                <Title level={3} style={{ margin: 0 }}>
                  {account?.name || ""}
                </Title>
                <Text type="secondary">
                  {account?.settings?.document || ""}
                </Text>
              </Space>
            </Col>
          </Row>

          <Divider />

          <div style={{ padding: "0 20px" }}>
            <Title level={4} style={{ textAlign: "center", marginBottom: 32 }}>
              Escolha o plano ideal para você
            </Title>

            {plans.length === 0 ? (
              <Empty description="Nenhum plano disponível no momento." />
            ) : (
              <Row gutter={[24, 24]} justify="center">
                {plans.map((plan: any) => {
                  const planData = plan.data || plan;
                  return (
                    <Col xs={24} sm={12} md={8} key={planData.id}>
                      <Card
                        hoverable
                        style={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          flex: 1,
                        }}
                      >
                        <div style={{ textAlign: "center", marginBottom: 16 }}>
                          <Title level={4}>{planData.name}</Title>
                          <Title
                            level={2}
                            style={{ color: "#107B99", margin: "16px 0" }}
                          >
                            {formatCurrency(planData.price)}
                          </Title>
                          <Text type="secondary">
                            {frequencies.find(
                              (f) => f.value === planData.frequency
                            )?.label || planData.frequency}
                          </Text>
                        </div>

                        <div style={{ flex: 1 }}>
                          {planData.description && (
                            <Text>{planData.description}</Text>
                          )}
                        </div>

                        <List
                          header={<Text strong>O que está incluso:</Text>}
                          size="small"
                          dataSource={planData.services}
                          renderItem={(service: any, index) => (
                            <List.Item>
                              <List.Item.Meta
                                description={service?.name || "Serviço"}
                              />
                            </List.Item>
                          )}
                        />

                        <Button
                          type="primary"
                          size="large"
                          block
                          style={{ marginTop: 24 }}
                          onClick={() =>
                            handleSubscribe(planData.uuid || planData.id)
                          }
                        >
                          Contratar
                        </Button>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
}
